// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.toggle[data-v-ec03f544] {\n\tposition: fixed;\n\tdisplay: inline-block;\n\tleft: 0;\n\twidth: 44px;\n\theight: 44px;\n\tz-index: 1500;\n\tcursor: pointer;\n\ttransform: rotate(180deg);\n\tbackground-color: var(--color-main-background);\n\topacity: 1;\n}\n", ""]);
// Exports
module.exports = exports;
